import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=1854dd3c&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ErrorPage.vue?vue&type=style&index=0&id=1854dd3c&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1854dd3c",
  null
  ,true
)

export default component.exports